// extracted by mini-css-extract-plugin
export default {"page":"hY-z","cartModal":"iY-z","checkout":"jY-z","placeholder":"kY-z","account":"lY-z"};